var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreatorToolsTop1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 -4.37114e-07L50 10L50 50L10 50L5.88094e-06 40L0 4.72857e-06L40 -4.37114e-07Z",
    fill: "#1D1D1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.29 34.4703L25 28.7803L19.71 34.4703L16.17 30.6703L13 37.0003H37L33.83 30.6703L30.29 34.4703Z",
    fill: "#00F7AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7101 31.53L23.6801 27.27L24.9701 25.87L25.7001 26.63L26.3101 27.26L30.2901 31.53L32.8801 28.76L30.7001 24.39L28.7501 26.48L25.0001 22.46L21.2501 26.48L19.3001 24.39L17.1201 28.76L19.7101 31.53Z",
    fill: "#00F7AB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7498 23.55L29.7398 22.49L24.9998 13L20.2598 22.49L21.2498 23.55L23.8498 20.76L24.9698 19.55L25.7098 20.3L26.1398 20.75L28.7498 23.55Z",
    fill: "#00F7AB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatorToolsTop1);
export default __webpack_public_path__ + "static/media/creatorToolsTop1.f1db10334612299f060f5a8bb3f6c0ec.svg";
export { ForwardRef as ReactComponent };